import { HttpParams } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { Exercice } from '../../model/exercice.model';
import { ExerciceList } from '../../model/exerciceList.model';

export enum ExerciseTypes {
    GET_Exercise = '[Exercise] Get Exercise',
    SET_Exercise = '[Exercise] Set Exercise',
    GET_Exercise_URL = '[Exercise] Get Exercise FROM URL',
    GET_Exercise_SUCCESS = '[Exercise] Get Exercise Success',
    GET_Exercise_FAILURE = '[Exercise] Get Exercise Failure',
}

export const GetExercise = createAction(
    ExerciseTypes.GET_Exercise,
    props<{ params: HttpParams }>()
)

export const GetExercisefromurl = createAction(
    ExerciseTypes.GET_Exercise_URL,
    props<{ url: string }>()
)

export const GetExerciseSuccess = createAction(
    ExerciseTypes.GET_Exercise_SUCCESS,
    props<{ payload: ExerciceList }>()
)

export const GetExerciseFailure = createAction(
    ExerciseTypes.GET_Exercise_FAILURE,
)

export const SetExercice = createAction(
    ExerciseTypes.SET_Exercise,
    props<{ exercice: Exercice }>()
)